/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSparkles} from '@fortawesome/pro-duotone-svg-icons';

const PdSpecialRequestsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSparkles} {...props} />
);

export default PdSpecialRequestsIcon;
